// eslint-disable-next-line import/named
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationState, NotificationType } from '../../utils/Interface'

const initialState: NotificationState = {
    notifications: []
}

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        addNotification: (
            state,
            action: PayloadAction<{ message: string; type: NotificationType }>
        ) => {
            const { message, type } = action.payload;
            const id = new Date().getTime();

            // Supprimer toutes les notifications du même type
            state.notifications = state.notifications.filter(
                (notification) => notification.type !== type
            );

            // Ajouter la nouvelle notification
            state.notifications.push({ id, message, type });
        },
        removeNotification: (state, action: PayloadAction<number>) => {
            state.notifications = state.notifications.filter(
                (notification) => notification.id !== action.payload
            )
        }
    }
})

export const { addNotification, removeNotification } = notificationSlice.actions
export default notificationSlice.reducer
